/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useDispatch, useSelector } from 'react-redux'

import useUtils from './useUtilities'

import { updateUserProfile } from '@/Redux/userSlice'
import { type CardActivityWithId, type FeedbackTypesCard } from '@/models/card-activity/card-activity.model'

export function useUser() {
  const user = useSelector<any>(state => state.user)

  return user as {
    auth: UserAuth
    profile: UserProfile
  }
}

export function useAuthUser() {
  const auth = useSelector<any>(state => state.user.auth)

  return auth as UserAuth
}

export function useProfileUser() {
  const profile = useSelector<any>(state => state.user.profile)

  return profile as UserProfile
}

export function useUpdateUserProfile() {
  const dispatch = useDispatch()
  const { showSnackbar } = useUtils()

  const updateProfile = (updates: Partial<UserProfile>) => {
    // @ts-ignore
    dispatch(updateUserProfile(updates))
  }

  const hanldleSaveFeedbacksAsDefault = (card: CardActivityWithId) => {
    updateProfile({
      defaultGradingSettings: {
        feedback_types: card?.feedback_types ?? [],
      },
    })

    // @ts-ignore
    showSnackbar('Default instant feedback settings saved', 'success')
  }

  const handleSetDefaultGradingMethod = (value: string) => {
    const autoGradeValue = value !== 'manual'

    updateProfile({
      defaultGradingSettings: {
        grading_method: value as 'simple' | 'rubric' | 'manual',
        autoGrade: autoGradeValue,
      },
    })
  }

  return { updateProfile, hanldleSaveFeedbacksAsDefault, handleSetDefaultGradingMethod }
}

interface UserAuth {
  uid: string
  email: string
  displayName: string
  custom_claims: Record<string, any>
  createdAt: string
  lastLogin: string
  loaded: boolean
  loading: boolean
}

interface UserProfile {
  emailOptOut: boolean
  nativeLanguage: string
  speakableio: boolean
  onboardingState: string
  dateMade: {
    seconds: number
    nanoseconds: number
  }
  connectedGoogleClassroom: boolean
  emailVerified: boolean
  onboardingComplete: boolean
  savedSets: string[]
  additionalNativeLanguages: string[]
  recentRubrics: string[]
  isGoogleUser: boolean
  language: string
  studentDeviceType: string
  totalAssignmentsActivated: number
  displayName: string
  onboardingSteps: string[]
  totalStudentAssignmentsSubmitted: number
  owners: string[]
  additionalLanguages: string[]
  email: string
  adminStatus: string
  schoolId: string
  schoolName: string
  districtName: string
  image: {
    url: string | null
    path: string | null
  }
  roles: string[]
  lastAccess: {
    seconds: number
    nanoseconds: number
  }
  recentAssignments: string[]
  districtID: string
  loaded: boolean
  loading: boolean
  isTeacher: boolean
  defaultGradingSettings: {
    autoGrade?: boolean
    grading_criteria?: string
    grading_method?: 'simple' | 'rubric' | 'manual'
    passing_score?: number
    feedback_types?: FeedbackTypesCard[]
    rubricId?: string
    scoring_type?: string
    standardId?: string
    target_proficiency_level?: string
  }
  defaultAssignmentRepeat: number
  googleClassroomUserId?: string
  savedRubrics: string[]
  defaultRubricId?: string
  lastActiveEntityId?: string
  isStudent: boolean
}
